module.exports = __webpack_public_path__ + "static/img/ic_qb_sale_list@2x.06e9883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_qb_sale_list@2x.png
// module id = rAv1
// module chunks = 1